import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';
import membershipTemplate from './view/membership/membership.pug';
import personalTemplate from './view/personal/personal.pug';
import attributesTemplate from './view/attributes/attributes.pug';
import contactTemplate from './view/contact/contact.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.memberList', {
      url: '/members',
      template: listTemplate,
      controller: 'MemberListCtrl',
      controllerAs: 'memvm',
      authenticate: true,
      // prevent reload on url query string updates (filter)
      reloadOnSearch: false
    })
    .state('group.memberNew', {
      url: '/members/new',
      template: formTemplate,
      controller: 'MemberFormCtrl',
      controllerAs: 'memvm',
      authenticate: true
    })
    .state('group.memberView', {
      // :groupId = ancestor/context group, :id = personId
      url: '/members/:perId',
      template: viewTemplate,
      controller: 'MemberViewCtrl',
      abstract: true,
      controllerAs: 'memvm',
      authenticate: true
    })
    .state('group.memberView.membership', {
      url: '',
      template: membershipTemplate,
      authenticate: true
    })
    .state('group.memberView.personal', {
      url: '/personal',
      template: personalTemplate,
      controller: 'MemPersonalCtrl',
      controllerAs: 'pervm',
      authenticate: true
    })
    .state('group.memberView.attributes', {
      url: '/attributes',
      template: attributesTemplate,
      controller: 'MemAtrCtrl',
      controllerAs: 'mavm',
      authenticate: true
    })
    .state('group.memberView.contact', {
      url: '/contact',
      template: contactTemplate,
      controller: 'MemContactCtrl',
      controllerAs: 'convm',
      authenticate: true
    });
}];
